<div style="position: fixed; z-index: 9999; right: 0; top: 0; min-width: 55%;">
    <div *ngFor="let toast of toasters" class="{{cssClass(toast)}}">
        <span [innerHTML]="toast.message"></span>
        <button class="btn-close" (click)="removeAlert(toast)"></button>
    </div>
</div>
